// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import Link from '../../../../components/Link';
import { __ } from '../../../../i18n/l10n';

import Secondary from './Secondary';

const RedBubble = styled.span`
  width: 1.7em;
  height: 1.7em;
  min-width: 1.7em;
  min-height: 1.7em;
  background: ${({ theme }) => theme.grids.colors.redlight};
  border-radius: 50%;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.4em;
`;

const StyledSecondary = styled(Secondary)`
  && {
    text-transform: uppercase;
    font-size: 0.9em;
    padding-left: 4px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background: ${({ theme }) => theme.grids.colors.black};
  }
`;

type GridsPublicGridButtonProps = {
  className?: string;
  publicLink: string;
  publicGridsCount: number;
};

const GridsPublicGridButton = ({ className, publicGridsCount, publicLink }: GridsPublicGridButtonProps) => {
  return (
    <Link className={className} to={publicLink}>
      <StyledSecondary withRedBorder>
        <RedBubble>{publicGridsCount}</RedBubble>
        {publicGridsCount === 1 ? __('Public grid') : __('Public grids')}
      </StyledSecondary>
    </Link>
  );
};

export default GridsPublicGridButton;
